import getApiInstance from 'data/common/ApiCallGenerique';
import Translator from 'translator';
import { Toastr, Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';
import { getSocket } from '../../../fhe/common/AllSocketsMiddleware';
/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

export function getHomes(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllHomes(env))
            .then(({ data }) => {
                if (data.success) {
                    if (data.homes) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_HOMES`,
                            homes: data.homes,
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                    if (data.boxes) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_BOXES`,
                            boxes: data.boxes,
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getHomes - ', error);
                throw error;
            });
    };
}
export function getHomeDetails(env, homeId) {
    return dispatch => {
        return apiCaller
            .call(api.getHomeDetails(env, homeId))
            .then(({ data }) => {
                if (data.success) {
                    if (data.homeDetails) {
                        dispatch({
                            type: `${env.toUpperCase()}__UPDATE_HOME`,
                            homeId,
                            homeDetails: data.homeDetails,
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getHomeDetails - ', error);
                throw error;
            });
    };
}
export function updateHomeDetails(env, homeId, homeForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateHomeDetails(env, homeId, homeForm))
            .then(({ data }) => {
                if (!data.success) throw data.error;
                dispatch({
                    type: `${env.toUpperCase()}__UPDATE_HOME`,
                    homeId,
                    homeDetails: data.homeDetails,
                });

                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateHomeDetails - ', error);
                throw new Error(error);
            });
    };
}
export function addHome(env, homeForm) {
    return dispatch => {
        return apiCaller
            .call(api.addHome(env, homeForm))
            .then(({ data }) => {
                dispatch({
                    type: `${env.toUpperCase()}__UPDATE_HOMES`,
                    homes: data.homeDetails,
                });
                if (data.box) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_BOX`,
                        boxMac: data.boxMac,
                        box: data.box,
                    });
                }
                if (data.user) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_USERS`,
                        homeId: data.homeId,
                        homeUsers: data.user,
                    });
                }
                return { homeId: data.homeId, success: data.success };
            })
            .catch(error => {
                Logger.log('dataActions: addHome - ', error);
                throw error;
            });
    };
}

export function getHomeUsers(env, homeId) {
    return dispatch => {
        return apiCaller
            .call(api.getHomeUsers(env, homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_USERS`,
                        homeId,
                        homeUsers: data.homeUsers,
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getHomeUsers - ', error);
                throw error;
            });
    };
}
export function deleteHomeUser(env, homeId, userId) {
    return dispatch => {
        return apiCaller
            .call(api.deleteHomeUser(env, homeId, userId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__DELETE_USER`,
                        userId,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteHomeUser - ', error);
                throw error;
            });
    };
}
export function deleteHomeUserAndSwitchMaster(env, homeId, userId, masterId) {
    return dispatch => {
        return apiCaller
            .call(api.deleteHomeUserAndSwitchMaster(env, homeId, userId, masterId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__DELETE_AND_UPDATE_HOME_USER`,
                        userId,
                        homeUsers: data.homeUsers,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteHomeUser - ', error);
                throw error;
            });
    };
}
export function switchHomeMaster(env, homeId, masterId) {
    return dispatch => {
        return apiCaller
            .call(api.switchHomeMaster(env, homeId, masterId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_USERS`,
                        homeId,
                        homeUsers: data.homeUsers,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: switchHomeMaster - ', error);
                throw error;
            });
    };
}
export function resetPassword(env, userId, homeId) {
    return () => {
        return apiCaller
            .call(api.resetPassword(env, userId, homeId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: resetPassword - ', error);
                throw error;
            });
    };
}
export function resendWelcomeUserEmail(env, userId, homeId) {
    return () => {
        return apiCaller
            .call(api.resendWelcomeUserEmail(env, userId, homeId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: resendWelcomeUserEmail - ', error);
                throw error;
            });
    };
}
export function addHomeUser(env, homeId, userForm) {
    return dispatch => {
        return apiCaller
            .call(api.addHomeUser(env, homeId, userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_USERS`,
                        homeId,
                        homeUsers: data.homeUsers,
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: addHomeUser - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.${data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message}`,
                                'api.message.default',
                            ),
                            Translator.translate('api.message.intermediate_error'),
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addHomeUser - ', error);
                throw error;
            });
    };
}
export function addSpecialHomeUser(env, homeId, userForm) {
    return dispatch => {
        return apiCaller
            .call(api.addSpecialHomeUser(env, homeId, userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_USERS`,
                        homeId,
                        homeUsers: data.homeUsers,
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: addHomeUser - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.${data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message}`,
                                'api.message.default',
                            ),
                            Translator.translate('api.message.intermediate_error'),
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addHomeUser - ', error);
                throw error;
            });
    };
}
export function editHomeUser(env, homeId, userId, userForm) {
    return dispatch => {
        return apiCaller
            .call(api.editHomeUser(env, homeId, userId, userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_USERS`,
                        homeId,
                        homeUsers: data.homeUsers,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addHomeUser - ', error);
                throw error;
            });
    };
}

export function getHomeHistory(env, homeId, withActions = false) {
    return dispatch => {
        return apiCaller
            .call(api.getHomeHistory(env, homeId, withActions))
            .then(({ data }) => {
                if (data.success) {
                    if (data.historyActions) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_HISTORY_ACTIONS`,
                            historyActions: data.historyActions,
                        });
                    }
                    return data.homeHistory;
                }
                throw 'general.error.data_has_not_correctly_returned_by_server';
            })
            .catch(error => {
                Logger.log('dataActions: getHomeHistory - ', error);
                throw error;
            });
    };
}
export function getHomeTickets(env, homeId) {
    return () => {
        return apiCaller
            .call(api.getHomeTickets(env, homeId))
            .then(({ data }) => {
                return data.homeTickets;
            })
            .catch(error => {
                Logger.log('dataActions: getHomeTickets - ', error);
                throw error;
            });
    };
}

export function addHomeHistory(env, homeId, historyForm) {
    return () => {
        return apiCaller
            .call(api.addHomeHistory(env, homeId, historyForm))
            .then(({ data }) => {
                if (data.success) return data.homeHistory;
                else throw 'general.error.data_has_not_correctly_returned_by_server';
            })
            .catch(error => {
                Logger.log('dataActions: addHomeHistory - ', error);
                throw error;
            });
    };
}

export function getJournalisation(env, homeId, fromDate, toDate) {
    return dispatch => {
        return apiCaller
            .call(api.getJournalisation(env, homeId, fromDate, toDate))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_PRODUCTS`,
                        homeId,
                        products: data.products,
                    });
                    return data.homeJournalisation;
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
            })
            .catch(e => {
                Logger.log('dataActions: getJournalisation - ', e);
                throw e;
            });
    };
}

export function getStats(env, homeId, fromDate) {
    return () => {
        return apiCaller
            .call(api.getStats(env, homeId, fromDate))
            .then(({ data }) => {
                if (data.success) {
                    return data.homeStats;
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
            })
            .catch(e => {
                Logger.log('dataActions: getStats - ', e);
                throw e;
            });
    };
}

export function emailExists(env, email) {
    return () => {
        return apiCaller.call(api.emailExists(env, email)).catch(e => {
            Logger.log('dataActions: emailExists - ', e);
            throw e;
        });
    };
}

export function updateConsoProd(env, homeBox, type, productModules) {
    return () => {
        return getSocketMiddlewareInstance()
            .updateConsoProd(homeBox, type, productModules)
            .catch(error => {
                Logger.log('dataActions: updateConsoProd - ', error);
                throw error;
            });
    };
}

export function configureTendaRouter(middleware, macAddress, boxId) {
    return dispatch => {
        return getSocket(middleware)
            .configureTendaRouter(macAddress, boxId)
            .then(() => {})
            .catch(error => {
                Logger.log('dataActions: configureTendaRouter - ', error.message);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Homes/actions.js